import * as tslib_1 from "tslib";
import { setMailboxMessageConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { action, select } from 'satcheljs/lib/legacy';
import store from '../store/store';
import { signatureSaved } from './signatureSaved';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('saveSignatureOption')(function saveSignatureOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions, serviceOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    serviceOptions = {};
                    if (optionState.editorViewState.isDirty) {
                        userOptions.SignatureHtml = optionState.editorViewState.content;
                        serviceOptions.SignatureHtml = optionState.editorViewState.content;
                        // Reset isDirty so the save/discard buttons reset
                        optionState.editorViewState.isDirty = false;
                    }
                    if (optionState.signNewMails !== null) {
                        userOptions.AutoAddSignature = optionState.signNewMails;
                        serviceOptions.AutoAddSignature = optionState.signNewMails;
                    }
                    if (optionState.signReplies !== null) {
                        userOptions.AutoAddSignatureOnReply = optionState.signReplies;
                        serviceOptions.AutoAddSignatureOnReply = optionState.signReplies;
                    }
                    signatureSaved();
                    return [4 /*yield*/, setMailboxMessageConfiguration(serviceOptions)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveSignatureOption.js.map